import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: ({ smallMedia }) => (smallMedia ? '100%' : 'calc(100% - 2rem)'),
    marginLeft: 'auto',
    marginRight: 'auto'
  },

  start: {
    marginTop: '1.5rem',
    borderRadius: '1rem 1rem 0 0',
    boxSizing: 'border-box',
    paddingTop: '0.6rem',
    paddingBottom: ({ smallMedia }) => (smallMedia ? '0.5rem' : '0')
  },

  end: {
    marginTop: '-7px',
    marginBottom: '0.75rem',
    borderRadius: '0 0 1rem 1rem',
    boxSizing: 'border-box',
    minHeight: '1rem'
  }
}))

export default useStyles
